



























































import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component, Prop, Inject, Watch,
} from 'vue-property-decorator';
import { TransactionClassificationRule, TransactionClassificationRuleResource }
  from '@/api/transactionclassification/';
import { Plotly } from 'vue-plotly';

@Component({
  components: {
    Plotly,
  },
})
export default class PredictionSummaryDialog extends Vue {
    @Prop({ default: [] })
    rules!:Array<TransactionClassificationRule>;

    @Prop({ default: null })
    lastPredictionTime!:Date;

    dialog:boolean = false;

    friendlyLastPredictionText:string = 'Never';

    series:number[] = [];

    highPercentage:number = 0;

    chartData:any[] = [{
      values: [123, 456],
      rotation: 90,
      hole: 0.75,
      type: 'pie',
      textinfo: 'none',
      showlegend: false,
      labels: ['High Confidence', 'Low Confidence'],
      marker: {
        colors: ['#6AC2E1', '#D71F27'],
      },
    }]

    chartLayout:any = {
      width: 350,
      height: 200,
      margin: {
        t: 0, b: 0, l: 0, r: 0,
      },
      annotations: [
        {
          font: {
            size: 24,
          },
          showarrow: false,
          text: '',
          x: 0.5,
          y: 0.6,
        },
        {
          font: {
            size: 18,
          },
          showarrow: false,
          text: 'Total',
          x: 0.5,
          y: 0.45,
        },
        {
          font: {
            size: 18,
          },
          showarrow: false,
          text: 'Transactions',
          x: 0.5,
          y: 0.29,
        },
      ],
    }

    @Watch('dialog')
    onDialogToggle() {
      if (this.dialog && this.lastPredictionTime) {
        this.friendlyLastPredictionText = this.lastPredictionTime.toLocaleString();

        let lowConfidence:number = 0;
        let highConfidence:number = 0;
        this.rules.forEach((rule) => {
          const confidence:number = PredictionSummaryDialog.getConfidenceForRule(rule);
          if (confidence > 0 && rule.lastQueryCount) {
            if (confidence < 0.85) {
              lowConfidence += rule.lastQueryCount;
            } else {
              highConfidence += rule.lastQueryCount;
            }
          }
        });

        this.chartData[0].values = [highConfidence, lowConfidence];
        this.chartLayout.annotations[0].text = (lowConfidence + highConfidence).toString();

        this.highPercentage = Math.round(highConfidence * (100 / (highConfidence + lowConfidence)));
      }
    }

    static getConfidenceForRule(rule:TransactionClassificationRule):number {
      let confidence:number = 0;

      if (rule.predictions) {
        rule.predictions.forEach((prediction) => {
          if (prediction.confidence > confidence) {
            confidence = prediction.confidence;
          }
        });
      }

      return confidence;
    }
}
